import React from 'react';

import { corporate_landing_path } from '../../../../routes';

const CorporateInquiry = () => {
  return (
    <div className="-mx-16 mt-48 border-0 border-t-2 border-solid border-grayscale-gray px-16 pt-32 font-suisse-screen text-disclosure-lg text-black sm:mx-0 sm:px-0 sm:pt-16">
      Interested in a group or corporate subscription?
      <a
        href={corporate_landing_path()}
        className="ml-4 text-primary-magenta visited:text-primary-magenta"
      >
        Explore options here.
      </a>
    </div>
  );
};

export default CorporateInquiry;
